export const RegistrationCaseType = Object.freeze([
    "Alta hospitalaria",
    "Alta hospitalario",
    "Alta express",
    "Reconsideración de Alta",
    "Reconsideración de Alta",
    "Reconsideración de Dictamen",
    "Reconsideracion de Dictamen",
    "Reconsideracion de dictamen",
]);

export const CaseTypeSlaFlagColumn = Object.freeze([
    "Alta hospitalaria",
    "Alta hospitalario",
    "Alta express",
    "Reconsideración de Alta",
    "Reconsideración de Alta",
]);

export const AxaCategoriesVip = Object.freeze([
    "VIP",
]);

export const AxaCategoriesOthersNotVisible = Object.freeze([
    "CUIDADO INTEGRAL",
    "VIP - CUIDADO INTEGRAL",
]);
